import { sk, pl, cs, de } from 'date-fns/locale';
import { I18nLocale } from 'utils';

export const getDateFnsLocale = (locale: I18nLocale) => {
	switch (locale) {
		case 'pl-PL':
			return pl;
		case 'sk-SK':
			return sk;
		case 'cs-CZ':
			return cs;
		case 'de-DE':
			return de;
		default:
			return pl;
	}
};
